import { Getter, Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { _Page2Data, _Page2Items, _PageAttributes2Component, _PageItem2Article, _PageItem2Channel, _PageItem2Collection, _PageItem2Link, _PageItem2Show, _PageItem2TaxonomyNode, _PageItem2Video, } from "@discovery/sonic-api-ng-optics-gen/lib/page";
export * from "@discovery/sonic-api-ng-optics-gen/lib/page";
/**
 * Getters
 */
export const _PageGetter = Getter.of();
export const _PageResponseGetter = Getter.of();
export const _PageItemGetter = Getter.of();
/**
 * Collection related lenses
 */
export const _Page2Col = Fold.compose(_Page2Items, _PageItem2Collection);
export const _Page2Link = Fold.compose(_Page2Items, _PageItem2Link);
export const _Page2Show = Fold.compose(_Page2Items, _PageItem2Show);
export const _Page2Channel = Fold.compose(_Page2Items, _PageItem2Channel);
export const _Page2TaxonomyNode = Fold.compose(_Page2Items, _PageItem2TaxonomyNode);
export const _Page2Video = Fold.compose(_Page2Items, _PageItem2Video);
export const _Page2Article = Fold.compose(_Page2Items, _PageItem2Article);
export const _Page2ColDataMetaM = Fold.compose(_Page2Data, Lens.prop("meta"));
export const _Page2TemplateId = Fold.compose(_PageAttributes2Component, M._Just(), Lens.prop("templateId"));
export const _Page2CustomAttributes = Fold.compose(_PageAttributes2Component, M._Just(), Lens.prop("customAttributes"));

